import React from 'react'
import { Field } from '../../../form'
import { Translation } from 'react-i18next'
import { MenuItem } from '@material-ui/core'
import classNames from 'classnames'

const WorkField = React.memo(({ classes, fieldOfWork, control, disabled }) => {
  return (
    <Translation>
      {(t) => (
        <Field
          name="field_work"
          inputType="select"
          className={classNames(classes.select, classes.resize)}
          label={t('employer.companyProfile.label6')}
          control={control}
          disabled={disabled}
        >
          {createWorkFieldItems(t, fieldOfWork)}
        </Field>
      )}
    </Translation>
  )
})

const createWorkFieldItems = (t, fields) => {
  const list = fields.length > 0 ? fields : [{ Field_id: 0 }]
  return list.map((Field_name, index) => (
    <MenuItem key={index} value={Field_name.Field_id}>
      {t(`employer.fieldOfWork.${Field_name.Field_id}`)}
    </MenuItem>
  ))
}

export default WorkField
